import * as React from 'react';
import { SVGProps } from 'react';

const IconPrinterStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 3V2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1-1h6v1H3V2Zm0 6V6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2h1V4H2v4h1Zm1-2h4v4H4V6Z"
    />
  </svg>
);
export default IconPrinterStrokedSizeXs;
